<template>
    <div>
        <div class="test-indicator-block" v-if="questions">
            <div class="indicate-50">
                <div class="indicate-num green">{{legendsCount.correct}}</div>
                <div class="indicate-text">Correct</div>
            </div>
            <div class="indicate-50">
                <div class="indicate-num red">{{legendsCount.incorrect}}</div>
                <div class="indicate-text">Incorrect</div>
            </div>
            <div class="indicate-50">
                <div class="indicate-num grey">{{legendsCount.notAttempted}}</div>
                <div class="indicate-text">Not Attempted</div>
            </div>
            <div class="indicate-50">
                <div class="indicate-num blue">{{legendsCount.partiallyCorrect}}</div>
                <div class="indicate-text">Partially Correct</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "LegendsPreview",
    props: ["questions"],
    data() {
        return {
        };
    },
    computed: {
        legendsCount() {
            let legendsCount = {
                correct: 0,
                incorrect: 0,
                notAttempted: 0,
                partiallyCorrect: 0
            };
            this.questions.forEach(val => {
                if (val.ansStatus == this.PAST_QUESTION_STATUS.CORRECT) {
                    legendsCount.correct++;
                }
                if (val.ansStatus == this.PAST_QUESTION_STATUS.INCORRECT) {
                    legendsCount.incorrect++;
                }
                if (val.ansStatus == this.PAST_QUESTION_STATUS.NOT_ATTEMPTED) {
                    legendsCount.notAttempted++;
                }
                if (
                    val.ansStatus == this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT
                ) {
                    legendsCount.partiallyCorrect++;
                }
            });
            return legendsCount
        }

    },
};
</script>